// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { GroupFacadeService } from './../../../state/groups/group.facade';
import { GroupDetailsFacadeService } from '@app/access-management/state/group-details/group-details.facade';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, take, filter } from 'rxjs/operators';
import {
  RoleDetail,
  needsLoading,
  Loaded,
  MaybeLoadable,
  Role,
  Loadable,
  readParameterFromRouterState,
  RolesService,
  AlertType,
  QueueAlertAction,
  IAM_ROUTE,
  GoAction
} from '@app/core';
import { Group } from '@app/access-management/core/models/groups.model';
import {
  selectRoleDetail,
  LoadingRoleDetailsAction,
  State,
  SelectGroupsForRoleAction
} from '@app/access-management/state';
import { SelectedRows } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';

@Component({
  selector: 'app-role-details-groups-add',
  templateUrl: './role-details-groups-add.component.html',
  styleUrls: ['./role-details-groups-add.component.scss']
})
export class RoleDetailsGroupsAddComponent implements OnInit {
  role$: Observable<Role | undefined>;
  groups$: any;
  roleId: any;
  selectedGroups: Group[] | undefined = undefined;

  groupsTableColumns = [
    { name: 'Group Name', prop: 'group_name' },
    { name: 'Organization', prop: 'account_name' },
    { name: 'Description', prop: 'description' }
  ];
  roleGroups$: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<State>,
    private roleDetailsFacadeService: RoleDetailsFacadeService,
    private groupFacadeService: GroupFacadeService
  ) {
    this.roleId = readParameterFromRouterState(this.activatedRoute, 'id');

    this.roleDetailsFacadeService.initialize(this.roleId);

    this.role$ = this.roleDetailsFacadeService.role$;
    this.roleGroups$ = this.roleDetailsFacadeService.getRoleGroups(this.roleId);
  }

  ngOnInit() {}

  onSelect(selectedGroups: Group[]) {
    this.selectedGroups = selectedGroups;
  }

  selectGroups() {
    if (!this.selectedGroups) {
      return;
    }
    this.store.dispatch(new SelectGroupsForRoleAction({ roleId: this.roleId, selectedGroups: this.selectedGroups }));
  }

  cancel() {
    this.goToRoleDetailsPage();
  }

  onSelectRows(rows: SelectedRows) {
    this.selectedGroups = rows.selected;
  }

  private goToRoleDetailsPage() {
    this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'roles', this.roleId]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-details/role-details-groups-add/role-details-groups-add.component.ts